import { useTenant } from 'lib/hooks/useTenant';
import { useContext } from 'react';
import { TncApprovalContext } from './tnc-approval.context';

const useTncApproval = () => {
  const ctx = useContext(TncApprovalContext);
  const { isDA, isGwat } = useTenant();
  const isRequired = isDA || isGwat;

  if (!ctx) {
    return {
      isApproved: false,
      toggle: () => {},
      isRequired,
    } as const;
  }

  const toggle = () => {
    ctx.setIsApproved((value) => !value);
  };

  return {
    isApproved: ctx.isApproved,
    toggle,
    isRequired,
  } as const;
};

export { useTncApproval };
